import { useEffect, useState } from 'react'
import { apiClient } from '@/api/client'

export function useBrandRegistrationStatus() {
  const [hasApprovedBrand, setHasApprovedBrand] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    apiClient.get<{ has_approved_brand: boolean }>('/v1/brands/my-registration-status')
      .then(res => setHasApprovedBrand(res.data.has_approved_brand))
      .catch(() => { /* backend unavailable — assume no approved brand */ })
      .finally(() => setLoading(false))
  }, [])

  return { hasApprovedBrand, loading }
}
